import { Link } from 'react-router-dom';
import { getPath, Path } from 'urlBuilder';

import { messages } from './Navigation.messages';

export const homeTab = {
    value: '-1',
    label: messages.home,
    as: Link,
    to: getPath(Path.customerFeedback),
};
